




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({
    name: 'c-start-sign-modal'
})
export default class CBudgetUserStartSignModal extends Vue {
    private showModal = false;

    private showEvent() {
        this.showModal = true;
    }

    private recalClk() {
        this.showModal = false;
        this.$emit('startSign');
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get title() {
        const obj = {
            title: this.getBudgetText('button.sign'), // Подписать
            comment: this.getBudgetText('other.user_start_sign'), // Внимание! В данном режиме подписываются данные по текущим программам. Программы развития подписываются в режиме «Бюджетные инвестиционные проекты»
            sign_ecp: this.getBudgetText('button.sign_ecp'), // Подписать ЭЦП
            cancel: this.getBudgetText('button.cancel') // Отменить
        }
        return obj;
    }
}
